import {
  Button,
  Col,
  Input,
  Modal,
  Pagination,
  PaginationProps,
  Row,
  Table,
  TableProps,
  Tag,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { BaseApi } from "../base.api";
import { useNavigate } from "react-router-dom";
interface SourceData {
  name: string;
  parent: string;
}
const Sources: React.FC = () => {
  const [sourceData, setSourceData] = useState<SourceData[]>([]);
  const [sourceAllData, setSourceAllData] = useState<SourceData[]>([]);
  const [sourceTransferData, setSourceTransferData] = useState<SourceData[]>(
    []
  );
  const [searchText, setSearchText] = useState<string>("");
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [modalPage, setModalPage] = useState(1);
  const [modalPageSize, setModalPageSize] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasNextPageModal, setHasNextPageModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<SourceData[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedModalRowKey, setSelectedModalRowKey] = useState<React.Key[]>(
    []
  );
  const [openModal, setOpenModal] = useState(false);
  const [searchSourceTransfer, setSearchSourceTransfer] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadSources();
    setLoading(true);
  }, [current, pageSize, searchText]);

 
  useEffect(() => {
    if (openModal) {
      loadModalTransferSources();
      setLoading(true);
    }
  }, [modalPage, modalPageSize, searchSourceTransfer, openModal]);

  const loadSources = async () => {
    setLoading(true);
    const offset = (current - 1) * pageSize;
    const limit = pageSize;
    const response = await new BaseApi().fetchData(
      `/common-service/v1/tags/source-tag/admin?offset=${offset}&limit=${limit}&key=${searchText}`
    );
    if (response?.data.data) {
      setSourceData(response?.data.data);
      setSourceAllData(response?.data.data);
      // setSourceTransferData(response?.data.data)
      setHasNextPage(response?.data.data.length === pageSize);
    } else {
      setSourceData([]);
      setHasNextPage(false);
    }
    
    setLoading(false);
  };

  const loadModalTransferSources = async () => {
    setLoading(true);
    const offset = (modalPage - 1) * modalPageSize;
    const limit = modalPageSize;
    const response = await new BaseApi().fetchData(
      `/common-service/v1/tags/source-tag/admin?offset=${offset}&limit=${limit}&key=${searchSourceTransfer}`
    );

    if (response?.data.data) {
      setSourceTransferData(response?.data.data);
      setHasNextPageModal(response?.data.data.length === modalPageSize);
    } else {
      setSourceTransferData([]);
      setHasNextPageModal(false);
    }
    const sourceData = response?.data.data
    if (sourceData && current === 1 && searchText.trim() == ""
      ) {
      const careerPageSource = {
        id: "CAREER_PAGE",
        name: "Career Page",
        count: 0,
        status: 1,
        parent: null,
      };
      sourceData.unshift(careerPageSource);
    }
    setSourceData(sourceData);
    setLoading(false);
  };
  const handleTransferSource = async () => {
    const key = 'transferMsg';            
    message.loading({ content: 'Transferring...', key, duration: 0 });
        const RecevierSource = selectedModalRowKey[0];
    const sentSource = selectedRows.map((item: any) => item.id
    );
    const isCareerPage = RecevierSource === "CAREER_PAGE";
    const data = {
      companyId: null,
      appIds: sentSource,
      toCareerPage: isCareerPage,
      toSourceId: RecevierSource,
    };
    try {
      const response = await new BaseApi().postData(
        "/candidate-service/operations/applications/source",
        data
      );

      if (response?.status === 201) {
        message.success({ content: 'Transfer successfully', key, duration: 2 });
      } else {
        message.error({ content: 'Unknown error', key, duration: 2 });
      }
  
    } catch (error) {
      message.error({ content: 'Transfer failed', key, duration: 2 });
    }
  };

  const searchData = async (value: any) => {
    setSearchText(value);
    setCurrent(1);
  };

  const sourceDelete = async (id: string) => {
    const response = await new BaseApi().deleteData(
      `/common-service/v1/tags/source-tag/${id}`
    );
    if (response?.status === 200) {
      message.success("Deleted successfully")
      console.log("succesfully");
    } else {
      message.error("Unknow error")
      console.log("Failed");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Target",
      key: "parent",
      render: (record: any) =>
        record.parent ? <Tag>{record.parent?.name}</Tag> : "-",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Action",
      render: (record: any) => (
        <div style={{ display: "flex", gap: 13 }}>
          <Button
            onClick={(e) => {
              navigate("/main/sources/update", { state: { id: record.id } });
            }}
          >
            Edit
          </Button>
          <Button onClick={() => sourceDelete(record.id)}>Delete</Button>
        </div>
      ),
    },
  ];

  const transferColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      //   render: (text) => <a>{text}</a>,
    },
    {
      title: "Target",
      key: "parent",
      render: (record: any) =>
        record.parent ? <Tag>{record.parent?.name}</Tag> : "-",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
  ];
  const start = () => {
    setLoading(true);
    setSelectedRows([]);
    setSelectedRowKeys([])
    setSearchText("");
    setLoading(false);
  };
  const modalClose = () => {
    setOpenModal(false);
    setSelectedModalRowKey([]);
    setSearchSourceTransfer("");
  };

  const handlePaginationChange = (page: number, pageSize: number) => {
    setCurrent(page);
    setPageSize(pageSize);
    
  };
  const handleOk = () => {
    setOpenModal(false);
    handleTransferSource();
    setSearchSourceTransfer("");
    setSelectedModalRowKey([]);
    start();
  };

  const handleModalTransfer = () => {
    setOpenModal(true);
  };
  const searchTransferSource = async (value: any) => {
    const escapedVal = value.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");
    const regex = new RegExp(escapedVal, "i");
    const data = sourceAllData.filter((data: any) => {
      const filterSource = regex.test(data.name);
      return filterSource;
    });
    setSearchSourceTransfer(value);
    setModalPage(1);
    setSourceTransferData(data);
  };

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: SourceData[]) => {
      setSelectedRows(newSelectedRows)
      setSelectedRowKeys(newSelectedRowKeys)
  },
};
 

  const rowSelectionModal = {
    selectedRowKeys: selectedModalRowKey,
    onChange: (selectedRowKeys: any) => setSelectedModalRowKey(selectedRowKeys),
  };

  const hasSelected = selectedRowKeys.length > 0;
  return (
    <div>
      <Modal
        width={1000}
        open={openModal}
        onCancel={modalClose}
        onOk={handleOk}
      >
        <Input
          style={{ width: "50%", marginBottom: "12px" }}
          placeholder="search..."
          value={searchSourceTransfer}
          onChange={(e) => {
            searchTransferSource(e.target.value);
          }}
        />
        <Table
          rowKey="id"
          dataSource={sourceTransferData}
          columns={transferColumns}
          pagination={{
            current: modalPage,
            pageSize: modalPageSize,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (page, pageSize) => {
              setModalPage(page);
              setModalPageSize(pageSize);
            },
            showSizeChanger: true,
            showTitle: false,
            simple: true,
            showTotal: () => null,
            total: hasNextPageModal
              ? modalPage * modalPageSize + 1
              : modalPage * modalPageSize,
          }}
          rowSelection={rowSelectionModal}
          loading={loading}
        />
      </Modal>
      <h1>Sources</h1>
      <Row justify="space-between" style={{ marginBottom: 20, gap: 12 }}>
        <Col xs={12} lg={6}>
          <Input
            value={searchText}
            placeholder="Write to search.."
            onChange={(e) => {
              searchData(e.target.value);
            }}
          />
        </Col>
        <Col
          xs={12}
          lg={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Button onClick={handleModalTransfer} disabled={!hasSelected}>
            Transfer
          </Button>
        </Col>
      </Row>
      <Button onClick={start} disabled={!hasSelected}  style={{ marginBottom: "12px" ,marginRight:"12px"}}>
        Reload
      </Button>
      {hasSelected ? `Selected ${selectedRowKeys.length} items` : null}
      {hasSelected ? (
        <div
          style={{
            marginBottom: "12px",
            backgroundColor: "#e1faeb",
            padding: "12px",
          }}
        >
          {selectedRows?.map((item) => {
            return <>{item.name} , </>;
          })}
        </div>
      ) : (
        ""
      )}
      <Table
        columns={columns}
        rowKey = "id"
        dataSource={sourceData}
        pagination={{
          current: current,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          onChange: handlePaginationChange,
          total: hasNextPage ? current * pageSize + 1 : current * pageSize,
          showSizeChanger: true,
          showTotal: () => null,
          showTitle: false,
          simple: true,
          showQuickJumper: false,
        }}
        rowSelection={rowSelection}
        loading={loading}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default Sources;
